import { useEngineModeSignal } from '../../../rx/signal/useEngineModeSignal'
import createEngineRoot from './createEngineRoot'
import { EngineMode } from './EngineMode/EngineMode.enum'
import { getDefaultStateMapDisk } from '../state/getDefaultStateMapDisk'

// placeholder for declaring intent
const createEngineForGamePlay = function () {
  const engine = createEngineRoot(getDefaultStateMapDisk())
  const [, setEngineMode] = useEngineModeSignal(engine)
  setEngineMode(EngineMode.Game)
  return engine
}

export default createEngineForGamePlay
